import { render, staticRenderFns } from "./BankAddEditModal.vue?vue&type=template&id=20792dc8"
import script from "./BankAddEditModal.vue?vue&type=script&lang=js"
export * from "./BankAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports